import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45d891ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "routines" }
const _hoisted_2 = {
  key: 0,
  class: "section-heading"
}
const _hoisted_3 = {
  key: 1,
  class: "section-heading"
}
const _hoisted_4 = { class: "section-heading" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Routines", -1))
const _hoisted_6 = { class: "search" }
const _hoisted_7 = { class: "search-inputs" }
const _hoisted_8 = { class: "search-bar" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search fa-lg" })
], -1))
const _hoisted_10 = { class: "checkbox-button" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Reply required")
], -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "seperator" }, null, -1))
const _hoisted_14 = { class: "filter" }
const _hoisted_15 = { class: "form-col" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Closing date(range)", -1))
const _hoisted_17 = { class: "date-range" }
const _hoisted_18 = { class: "form-col" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Address", -1))
const _hoisted_20 = { class: "date-range" }
const _hoisted_21 = { class: "form-col" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Investigation type", -1))
const _hoisted_23 = { class: "sml-select" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "form-col" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Status", -1))
const _hoisted_28 = { class: "sml-select" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "form-col" }
const _hoisted_32 = {
  key: 0,
  class: "reset-filter"
}
const _hoisted_33 = {
  class: "bottom-half",
  style: {"width":"100%","overflow":"auto"}
}
const _hoisted_34 = { class: "ls-table" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "text" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = ["colspan"]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = ["colspan"]
const _hoisted_43 = { key: 2 }
const _hoisted_44 = ["colspan"]
const _hoisted_45 = { "data-label": "Practice name" }
const _hoisted_46 = { "data-label": "Practice ID" }
const _hoisted_47 = { "data-label": "Closing date" }
const _hoisted_48 = { "data-label": "Investigation type" }
const _hoisted_49 = { "data-label": "Action" }
const _hoisted_50 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_date_picker = _resolveComponent("date-picker")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.loadingDataSet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_LoadingIndicator)
        ]))
      : (_ctx.errorLoadingDataSet)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_ErrorIndicator)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Search practice name or ID",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchKeyword) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.searchKeyword]
                    ]),
                    _hoisted_9
                  ]),
                  _createElementVNode("label", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.isReplyRequired) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.isReplyRequired]
                    ]),
                    _hoisted_11
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn btn-default transparent mr-2",
                  disabled: _ctx.loadingContent,
                  onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.showAdvancedFilter = !_ctx.showAdvancedFilter), ["prevent","stop"]))
                }, [
                  _createTextVNode(" Advanced Filter"),
                  _createElementVNode("span", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(['fal', _ctx.showAdvancedFilter ? 'fa-angle-up' : 'fa-angle-down'])
                    }, null, 2)
                  ])
                ], 8, _hoisted_12)
              ]),
              (_ctx.showAdvancedFilter)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_date_picker, {
                            value: _ctx.closingDateRange,
                            "onUpdate:value": _cache[3] || (_cache[3] = $event => ((_ctx.closingDateRange) = $event)),
                            range: "",
                            format: "DD/MM/YYYY",
                            "input-class": "narrow"
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "narrow",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.advanceFilter.address) = $event)),
                            placeholder: "Search address"
                          }, null, 512), [
                            [_vModelText, _ctx.advanceFilter.address]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.advanceFilter.investigationTypeId) = $event))
                          }, [
                            _hoisted_24,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investigationTypes, (iT) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: iT.id
                              }, _toDisplayString(iT.name), 9, _hoisted_25))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, _ctx.advanceFilter.investigationTypeId]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.advanceFilter.routineStatusId) = $event))
                          }, [
                            _hoisted_29,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routineStatuses, (s) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: s.id
                              }, _toDisplayString(s.name), 9, _hoisted_30))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, _ctx.advanceFilter.routineStatusId]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("button", {
                          class: "btn btn-secondary sml",
                          onClick: _cache[7] || (_cache[7] = $event => (_ctx.applyFilter()))
                        }, " Apply filter ")
                      ])
                    ]),
                    (_ctx.filterApplied)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createTextVNode(" Or "),
                          _createElementVNode("a", {
                            class: "link2",
                            onClick: _cache[8] || (_cache[8] = $event => {_ctx.resetFilter();})
                          }, "reset all")
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("table", _hoisted_34, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
                      return (_openBlock(), _createElementBlock("th", {
                        class: _normalizeClass([ h.sortable ? 'sortable' : '']),
                        onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_36, _toDisplayString(h.text), 1),
                          (h.sortable)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', h.sortMethod])
                              }, _hoisted_38, 2))
                            : _createCommentVNode("", true)
                        ])
                      ], 10, _hoisted_35))
                    }), 256))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_ctx.loadingContent)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                        _createElementVNode("td", {
                          colspan: _ctx.tableHeadings.length
                        }, [
                          _createVNode(_component_LoadingIndicator)
                        ], 8, _hoisted_40)
                      ]))
                    : (_ctx.errorLoadingContent)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                          _createElementVNode("td", {
                            colspan: _ctx.tableHeadings.length
                          }, [
                            _createVNode(_component_ErrorIndicator)
                          ], 8, _hoisted_42)
                        ]))
                      : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.routines.length == 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                            _createElementVNode("td", {
                              colspan: _ctx.tableHeadings.length
                            }, "No Records", 8, _hoisted_44)
                          ]))
                        : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.routines.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.routinesDisplay, (i) => {
                              return (_openBlock(), _createElementBlock("tr", null, [
                                _createElementVNode("td", _hoisted_45, _toDisplayString(i.practice.branchId == null ? i.practice.name :
                  i.practice.name + ' (' + i.practice.firmTradingName + ')'), 1),
                                _createElementVNode("td", _hoisted_46, _toDisplayString(i.practice.branchId == null ?
                  i.practice.firmId : i.practice.firmId + ' - ' +
                  i.practice.branchId), 1),
                                _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.$formatDate(i.closedDate)), 1),
                                _createElementVNode("td", _hoisted_48, _toDisplayString(i.investigationTypeName), 1),
                                _createElementVNode("td", _hoisted_49, [
                                  _createElementVNode("button", {
                                    class: "btn btn-default sml transparent ml-1",
                                    onClick: _withModifiers($event => (_ctx.addToInvestigation(i)), ["prevent","stop"])
                                  }, " Add inv ", 8, _hoisted_50)
                                ])
                              ]))
                            }), 256))
                          : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 64))
  ]))
}